import React, {useState, useEffect} from 'react';
import './Sidebar.css';
import {Avatar, Button} from '@material-ui/core';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import db from './firebase';

function Sidebar({userId, about}) {
    const [userImg, setUserImg] = useState([])
    useEffect(() => {
        db.collection('posts').where('userId','==',userId).onSnapshot(
            (snapshot)=>setUserImg(snapshot.docs.map((doc)=>({
                id:doc.id, data:doc.data()
            })))
        )
    }, [])
    return (
        <div className={`sidebar1 ${!about? "side__show":"side__hide"}`}>
            <div className="sidebar info">
                <h3> Info</h3>
                <p><BusinessCenterOutlinedIcon /> Profession</p>
                <p><HomeWorkOutlinedIcon /> Live in</p>
                <p><RoomOutlinedIcon /> From</p>
                <Button>View Detail</Button>
            </div>
            <div className="sidebar">
                <h3> Photo</h3>
                <div className="photo__grid">
                    {
                        userImg.map(userImgs=>(
                            <img src={userImgs.data.image} />
                        ))
                    }
                </div>
                <Button>View All</Button>
            </div>
            <div className="sidebar">
                <h3> Friends</h3>
                <div className="friend__grid">
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                    <div className="profile__list">
                        <Avatar src="" className="pro__avatar"/><p>Ye Min Htwe</p>
                    </div>
                </div>
                <Button>View All</Button>
            </div>
            <p className="footer__text foot">Privacy . Terms . Memory Site &copy; {new Date().getFullYear()} : Coded by YMH</p>
        </div>
    )
}

export default Sidebar

/*
                    <img src="image/1.jpg" className="first__img"/>
                    <img src="image/2.jpg" />
                    <img src="image/3.jpg" className="second__img"/>
                    <img src="image/4.jpg" />
                    <img src="image/5.jpg" />
                    <img src="image/1.jpg" />
                    <img src="image/2.jpg" className="third__img"/>
                    <img src="image/3.jpg" />
                    <img src="image/4.jpg" className="end__img"/>
*/